module.exports = __webpack_public_path__ + "media/images/ui__textCross--dark-d4c38e26c02a2aa724570f7f68d187ff.png";